/*eslint-disable*/
import api from '../';

class orthographGameItems {
    // GET: items
    static get(params) {
        return api.axios.get('/orthograph', { params }).then(({ data }) => data.data);
    }

    static getOwnTexts(params) {
        return api.axios.get('/orthograph/own-texts', { params }).then(({ data }) => data.data);
    }

    static store(params) {
        return api.axios.post('/orthograph', params).then(({ data }) => data.data);
    }

    static storeSound(file) {
        const formData = new FormData();
        formData.append('file', file);
        return api.axios
            .post('/orthograph/sound', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            })
            .then(({ data }) => data.data);
    }

    static update(id, params) {
        return api.axios.post(`/orthograph/${id}`, params);
    }

    static delete(id) {
        return api.axios.delete(`/orthograph/${id}`);
    }
}

export default orthographGameItems;
